import React, { useEffect } from 'react';
// import * as firebase from 'firebase/app';
// import 'firebase/messaging';
// import { firebaseCloudMessaging } from '../utils/firebase';
import { ToastContainer, toast } from 'react-toastify';
import { app, db, auth } from '../firebaseConfig';

import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { useHistory } from 'react-router-dom';

function PushNotificationLayout({ children }) {
  const router = useHistory();
  useEffect(() => {
    setToken();

    // Event listener that listens for the push notification event in the background
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', (event) => {
        console.log('event for the service worker', event);
      });
    }

    // Calls the getMessage() function if the token is there
    async function setToken() {
      // const token = await firebaseCloudMessaging.init();
      const messaging = getMessaging(app);

      // Retrieve the FCM token
      getToken(messaging)
        .then((token) => {
          if (token) {
            getMessage();
          }
        })
        .catch((error) => {
          console.error('Error getting FCM token:', error);
        });
      // const token = await firebaseCloudMessaging.init();
    }
  });

  // Handles the click function on the toast showing push notification
  const handleClickPushNotification = (url) => {
    router.push(url);
  };

  // Get the push notification message and triggers a toast to display it
  function getMessage() {
    const messaging = getMessaging(app);
    onMessage(messaging, (message) => {
      toast(
        <div onClick={() => handleClickPushNotification(message?.data?.url)}>
          <h5>{message?.notification?.title}</h5>
          <h6>{message?.notification?.body}</h6>
        </div>,
        {
          closeOnClick: false,
        }
      );
      const options = {
        body: body,
      };
      self.registration.showNotification(title, options);
    });
  }

  return (
    <>
      {/* <ToastContainer /> */}
      {children}
    </>
  );
}

export default PushNotificationLayout;
